module.exports = __webpack_public_path__ + "static/media/Scope-2.737a480b.png";